import { useRefineQuestionMutation } from 'util/rtk-api'

import { GetNewQuestionButton } from 'components/blue-button'
import DismissButton from 'components/dismiss-button'
import { useLesson } from 'contexts/lesson-context'
import styles from 'css/components/lesson-builder/feedback-overlay.module.css'
import React, { useState, useCallback, memo, useEffect } from 'react'
import { Question } from 'types'

export const FeedbackOverlay = memo(({ onEdit, setShowFeedback, questionId, question }: { onEdit: (payload: Partial<Question>) => void, setShowFeedback: (showFeedback: boolean) => void, questionId: string, question: Question }) => {
    const { lessonId } = useLesson()
    const [feedback, setFeedback] = useState('')
    const [refineQuestion, { isLoading }] = useRefineQuestionMutation()

    const handleSubmit = useCallback(async () => {
        try {
            const response = await refineQuestion({ lessonId, questionId, question, feedback }).unwrap()
            onEdit(response)
            setShowFeedback(false)
        } catch (error) {
            console.error('Error refining question:', error)
        }
    }, [lessonId, questionId, feedback, refineQuestion, onEdit, setShowFeedback])

    return (
        <div className="overlay">
            <div className="overlay-content-container">
                <div className="overlay-content-header">
                    Refine Question
                    <DismissButton onClick={() => setShowFeedback(false)} />
                </div>
                <div className="overlay-content-body">
                    <textarea
                        className={styles.feedbackInput}
                        placeholder="Please give feedback so we can generate a new and better question for you."
                        value={feedback}
                        onChange={(e) => setFeedback(e.target.value)}
                        rows={4}
                    />
                    <div className={styles.alignRight}>
                        <GetNewQuestionButton onClick={handleSubmit} />
                    </div>
                </div>
            </div>
        </div>
    )
})

export default FeedbackOverlay 